import { Card, Form, Segmented } from "antd";
import React from "react";
import { SmlAsset, SmlJsonQueryFilter } from "@src/types/intelligence-search";
import { MoreAction } from "@src/pages/intelligence-search/component/more-action";
import { InsightModal } from "@src/pages/intelligence-search/component/result/insight-modal";
import { Space } from "antd";
import { TableOutlined, LineChartOutlined } from "@ant-design/icons";
import { AutoGeneratedChartMemo as AutoGeneratedChartMemoV2 } from "@src/pages/intelligence-search/component/result/auto-generated-chart-v2";
import { IJobMeta } from "@src/types/ab-testing-exploration";
import { useSmlQueryContext } from "@src/pages/intelligence-search-v2/context/sml-query-context";
import { RawDataInsightMemo } from "@src/pages/intelligence-search/component/result/raw-data-insight";
import { PERMISSION_EXCLUDED_CHECK } from "@src/components/crud-permission-layout";
import { LoadingComponent } from "@src/components/loading-custom";
import { ISLoadingTips, LoadingMessage } from "@src/constant/loading-message";

export type SearchResultType = {
    data: Record<string, any>[];
    query: string;
    meta: IJobMeta;
    cache_hit: boolean;
    schema: any[];
    ref_assets: SmlAsset[];
};

export type DryRunInfo = {
    loading: boolean;
    message?: string[];
    statusCode?: number;
    meta?: Record<string, any>;
};

export const SearchResultCard: React.FC<{ selectedAssetsOrFilters: SmlJsonQueryFilter[] }> = ({
    selectedAssetsOrFilters,
}) => {
    const form = Form.useFormInstance();
    const { loadResult, isLoadingData } = useSmlQueryContext();
    const [viewMode, setViewMode] = React.useState("table");

    return (
        <div className={PERMISSION_EXCLUDED_CHECK}>
            {isLoadingData && <LoadingComponent message={LoadingMessage} tips={ISLoadingTips} />}
            {!!loadResult && !isLoadingData && (
                <Card>
                    <div className="flex items-center justify-end mb-4">
                        <Space>
                            <Segmented
                                // vertical
                                value={viewMode}
                                options={[
                                    { value: "table", icon: <TableOutlined /> },
                                    { value: "chart", icon: <LineChartOutlined /> },
                                ]}
                                onChange={setViewMode}
                            />
                            <InsightModal form={form} loadResult={loadResult} />
                            <MoreAction form={form} />
                        </Space>
                    </div>

                    <hr className="border-gray-100 " />

                    {viewMode === "chart" ? (
                        <AutoGeneratedChartMemoV2 data={loadResult?.data} />
                    ) : (
                        <RawDataInsightMemo
                            isLoading={isLoadingData}
                            loadResult={loadResult}
                            filters={selectedAssetsOrFilters}
                        />
                    )}
                </Card>
            )}
        </div>
    );
};
